// Внеаудиторная нагрузка в журнале ISS (подготовка к занятиям, методическая работа, контроль СРС, практики и т.п. — всё, что не
// лекции, практики, лабораторные, консультации, экзамены и зачёты): внесение «одной строкой».
//
// У такой работы нет пар и расписания; в карточке («Добавить») есть своя кнопка «Закрыть» — она вписывает в «часов» весь остаток
// нагрузки, и запись вносится сразу целиком (преподаватели стараются не дробить нагрузку).
// Ошибка базы ISS: «Ошибка арифметического переполнения для типа varchar, значение = 10.940000» — число передаётся в базу строкой
// с шестью знаками после точки и в поле не помещается, если оно 10 и больше (9.990000 — помещается, 10.940000 — нет). Поэтому
// всё, что не меньше 10 (12,34 и 12,5 тоже), приходится дробить на части до 9,99. (Проверено на живом ISS, журнал сервера.)
// Здесь — чистая логика (без браузера): разбиение, раскладка по датам.
const MAX_DIGITS = 3
exports.MAX_DIGITS = MAX_DIGITS

const DAY_RE = /^\d{4}-\d{2}-\d{2}$/
const MS_DAY = 24 * 60 * 60 * 1000
const addDays = (day, n) => new Date(Date.parse(day + 'T00:00:00Z') + n * MS_DAY).toISOString().slice(0, 10)
const weekday = day => new Date(day + 'T00:00:00Z').getUTCDay()

// «12,34» / 12.34 / "12.50" -> сотые доли (целое число): 1234, 1250; не число или не больше нуля -> 0
const toCents = v => {
  const n = Number(String(v == null ? '' : v).trim().replace(',', '.'))
  return Number.isFinite(n) && n > 0 ? Math.round(n * 100) : 0
}
exports.toCents = toCents

// сотые -> строка с разделителем sep без лишних нулей: 1234 -> «12,34», 1250 -> «12,5», 200 -> «2»
const fromCents = (c, sep = ',') => {
  const int = Math.floor(c / 100), frac = c % 100
  if (!frac) return String(int)
  return `${int}${sep}${String(frac).padStart(2, '0').replace(/0$/, '')}`
}
exports.fromCents = fromCents

// сколько цифр в записи числа (без разделителя и без лишних нулей): 12,34 -> 4; 2,66 -> 3; 12,5 -> 3; 10 -> 2
exports.digitsOf = v => fromCents(toCents(v)).replace(/\D/g, '').length

// наибольшая часть, которую ISS принимает, — 9,99 (в сотых долях)
const MAX_CENTS = 999
exports.MAX_CENTS = MAX_CENTS

// нужно ли дробить: число не меньше 10 (при записи в базу не помещается в varchar)
exports.needsSplit = v => toCents(v) > MAX_CENTS

// Разбиение остатка на части, каждая из которых вносится в ISS без ошибки (не больше 3 цифр: до 9,99). Части почти равные,
// сумма точно равна исходному числу. -> [сотые, ...]; пустой массив — нечего вносить.
exports.splitHours = v => {
  const total = toCents(v)
  if (!total) return []
  if (!exports.needsSplit(v)) return [total]
  const n = Math.ceil(total / MAX_CENTS)
  const base = Math.floor(total / n), extra = total % n
  const parts = Array.from({ length: n }, (_, i) => base + (i < extra ? 1 : 0))
  return parts
}

// Даты для частей: список рабочих дней периода [from, to] (воскресенье пропускается), части раскладываются по ним равномерно,
// по одной на дату. null — дат меньше, чем частей (две записи на одну дату и время ISS может не принять).
exports.spreadDates = (from, to, n) => {
  if (!DAY_RE.test(from || '') || !DAY_RE.test(to || '') || from > to || n < 1) return null
  const days = []
  for (let d = from; d <= to; d = addDays(d, 1)) if (weekday(d) !== 0) days.push(d)
  if (!days.length) days.push(from)
  if (n > days.length) return null
  if (n === 1) return [days[0]]
  return Array.from({ length: n }, (_, i) => days[Math.round(i * (days.length - 1) / (n - 1))])
}

// План внесения одной работы: остаток -> записи [{date: "ГГГГ-ММ-ДД", cents}] или {error}
// remaining — остаток нагрузки (число или «12,34»), from/to — период дат, на которые вносить
exports.plan = (remaining, from, to) => {
  const parts = exports.splitHours(remaining)
  if (!parts.length) return { error: 'Нечего вносить: нагрузка уже выполнена.' }
  const dates = exports.spreadDates(from, to, parts.length)
  if (!dates) return { error: `Нагрузку нужно разбить на ${parts.length} ${parts.length < 5 ? 'части' : 'частей'} (число ${fromCents(toCents(remaining))} не меньше 10 — ISS такое не принимает), а в периоде не хватает дат: нужно не меньше ${parts.length} рабочих дней.` }
  return { entries: parts.map((c, i) => ({ date: dates[i], cents: c })), split: parts.length > 1 }
}

// виды работ, которые вносятся как аудиторные (часы по парам) или с датой по расписанию — не внеаудиторные
exports.CLASSROOM_CATS = [0, 1, 2, 9, 10, 11]
exports.isNonAudit = cat => !exports.CLASSROOM_CATS.includes(cat)

// «2,43 / 10,92» -> {done, plan, remain} в сотых долях
exports.parseAe = s => {
  const m = String(s || '').match(/(\d+(?:[.,]\d+)?)\s*\/\s*(\d+(?:[.,]\d+)?)/)
  if (!m) return null
  const done = toCents(m[1]) , plan = toCents(m[2])
  return { done, plan, remain: Math.max(0, plan - done) }
}
